// src/components/AdminRoute.tsx
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';

const ADMIN_ROLES = ['RPWA_Admin', 'RPWA_Super'];

const AdminRoute: React.FC = () => {
  const { accounts } = useMsal();
  // Handle if accounts is empty
  if (!accounts || accounts.length === 0) {
    return <Navigate to="/" replace />;
  }

  const roles: string[] = accounts[0]?.idTokenClaims?.roles || [];

  const isAdmin = ADMIN_ROLES.some(role => roles.includes(role));
  return isAdmin ? <Outlet /> : <Navigate to="/" replace />;
};

export default AdminRoute;